// Percentage dat de onderaannemer nu mag factureren (SPEC_workflow 6.2–6.4, SPEC_calculatie 11).
//
// De berekening gebeurt altijd op het volledige project; het percentage is een facturatieschijf op dat
// totaal, geen aparte berekening, zodat de schijvenladder nooit opnieuw start. Bij meerwerk wordt de
// calculatie volledig herrekend en pas daarna het percentage toegepast. Het restpercentage is de
// openstaande post: het mag pas gefactureerd worden na oplevering aan de eindklant.
import { z } from 'zod';
import { round2 } from './schijven.js';

export const factuurPercentageSchema = z.object({
  /** Percentage dat nu gefactureerd mag worden, strikt tussen 0 en 100. */
  percentage: z.number().gt(0).lt(100),
  /** Waarom (bv. "winterfactuur", "akkoord met de onderaannemer"), zichtbaar in de calculatie en de log. */
  reden: z.string().trim().min(3, 'Geef een reden van minstens 3 tekens'),
  gezetDoor: z.string().nullable().optional(),
  gezetOp: z.string().nullable().optional(),
});
export type FactuurPercentage = z.infer<typeof factuurPercentageSchema>;

/**
 * Splitst wat factureerbaar is in "nu" en "na oplevering". Posten die per post open staan, blijven
 * open; het percentage geldt op de rest van de calculatie.
 */
export function splitsFacturatie(input: { totaal: number; openPosten: number; percentage?: number | null }): {
  nuFactureerbaar: number;
  percentageRest: number;
  openVoorOplevering: number;
} {
  const basis = round2(input.totaal - input.openPosten);
  const p = input.percentage;
  const nu = p != null && p > 0 && p < 100 ? round2((basis * p) / 100) : basis;
  const rest = round2(basis - nu);
  return { nuFactureerbaar: nu, percentageRest: rest, openVoorOplevering: round2(input.openPosten + rest) };
}

/** "70 %" met komma voor decimalen. */
export function fmtPercentage(p: number): string {
  return `${Number.isInteger(p) ? p : p.toLocaleString('nl-BE', { maximumFractionDigits: 2 })} %`;
}
